/* unplugin-vue-components disabled */import { render } from "./FavToggle.vue?vue&type=template&id=5c9ba0d0"
import script from "./FavToggle.vue?vue&type=script&lang=js"
export * from "./FavToggle.vue?vue&type=script&lang=js"

import "./FavToggle.vue?vue&type=style&index=0&id=5c9ba0d0&lang=scss"
script.render = render

export default script